<template>
	<div>
		<!-- <b-btn @click.prevent="$router.go(-1)" style="margin-left: 10px;">{{
			'Back' | translate
		}}</b-btn> -->
		<div class="margin-block"></div>

		<Franchise v-if="pageRole === 'master franchise' || pageRole === 'franchise'"></Franchise>
		<Teacher v-if="pageRole === 'teacher'"></Teacher>
		<Group v-if="pageRole === 'group'"></Group>
		<Student v-if="pageRole === 'student'"></Student>
	</div>
</template>

<script>
import Franchise from './Franchise.vue'
import Teacher from './Teacher.vue'
import Group from './Group.vue'
import Student from './Student.vue'

export default {
	name: 'Add',
	data() {
		return {
			groupName: '',
			groupAddress: '',
			myRole: '',
			teacherList: [],
			teacher: 0,
			password: '',
		}
	},
	components: {
		Franchise,
		Teacher,
		Group,
		Student,
	},
	computed: {
		pageRole() {
			return this.$route.params.role
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.margin-block {
	height: 50px;
}

.dropdown.v-select.searchable {
	background-color: #fff;
}
</style>
